import { compose, composeU } from '@bem-react/core';
import {
    Textinput as TextInputPresenter,
    withBaseline,
    withHasClear,
    withPinRoundClear,
    withSizeM,
    withSizeS,
    withThemeNormal
} from '@yandex-lego/components/Textinput/desktop';

const Textinput = compose(
    withBaseline,
    withHasClear,
    withThemeNormal,
    withPinRoundClear,
    composeU(withSizeS, withSizeM)
)(TextInputPresenter);

export default Textinput;
